import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X, ShoppingCart } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { useCommerce } from "../../context/CommerceContext";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const { count, setIsOpen } = useCart();
  const { commerceEnabled } = useCommerce();
  const CartButton = ({ className = "", variant = "desktop" }) => commerceEnabled ? (
    <button type="button" onClick={() => setIsOpen(true)} className={`relative flex items-center gap-2 text-white hover:text-signal-red transition-colors ${className}`} aria-label="Open cart" data-testid={variant === "desktop" ? "header-cart-button" : "header-cart-button-mobile"}>
      <ShoppingCart className="w-5 h-5" />
      <span className="absolute -top-2 -right-3 min-w-[18px] h-[18px] px-1 bg-signal-red text-white text-[11px] font-bold rounded-full flex items-center justify-center" data-testid={variant === "desktop" ? "header-cart-count" : "header-cart-count-mobile"}>{count}</span>
    </button>
  ) : null;
  
  // Helper to create correct links - anchor on homepage, full URL on other pages
  const getNavLink = (anchor) => {
    return isHomePage ? anchor : `/${anchor}`;
  };
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <div className="w-10 h-10 bg-signal-red flex items-center justify-center">
              <span className="font-black text-white text-xl">H</span>
            </div>
            <span className="font-heading font-black text-xl tracking-tight text-white uppercase">
              High Wall Lift
            </span>
          </Link>
          
          <nav className="hidden lg:flex items-center gap-6">
            <a href={getNavLink("#products")} className="text-gray-300 hover:text-white transition-colors font-medium" data-testid="nav-products">Products</a>
            <a href={getNavLink("#features")} className="text-gray-300 hover:text-white transition-colors font-medium" data-testid="nav-features">Features</a>
            <a href={getNavLink("#video")} className="text-gray-300 hover:text-white transition-colors font-medium" data-testid="nav-video">Video</a>
            <a href={getNavLink("#gallery")} className="text-gray-300 hover:text-white transition-colors font-medium" data-testid="nav-gallery">Gallery</a>
            <Link to="/blog" className="text-gray-300 hover:text-white transition-colors font-medium" data-testid="nav-blog">Blog</Link>
            <a href={getNavLink("#quote")} className="text-gray-300 hover:text-white transition-colors font-medium" data-testid="nav-quote">Quote</a>
            <a href={getNavLink("#contact")} className="text-gray-300 hover:text-white transition-colors font-medium" data-testid="nav-contact">Contact</a>
          </nav>
          
          <div className="hidden lg:flex items-center gap-4">
            <a href="tel:8067293701" className="flex items-center gap-2 text-white font-semibold hover:text-signal-red transition-colors" data-testid="header-phone">
              <Phone className="w-4 h-4" />
              (806) 729-3701
            </a>
            <CartButton className="ml-2" />
          </div>
          
          <div className="lg:hidden flex items-center gap-4">
          <CartButton className="mr-2" variant="mobile" />
          <button 
            className="lg:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
          </div>
        </div>
        
        {mobileMenuOpen && (
          <div className="lg:hidden pb-6 border-t border-white/10 mt-4 pt-4">
            <nav className="flex flex-col gap-4">
              <a href={getNavLink("#products")} className="text-gray-300 hover:text-white transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>Products</a>
              <a href={getNavLink("#features")} className="text-gray-300 hover:text-white transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>Features</a>
              <a href={getNavLink("#video")} className="text-gray-300 hover:text-white transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>Video</a>
              <a href={getNavLink("#gallery")} className="text-gray-300 hover:text-white transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>Gallery</a>
              <Link to="/blog" className="text-gray-300 hover:text-white transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
              <a href={getNavLink("#quote")} className="text-gray-300 hover:text-white transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>Request Quote</a>
              <a href={getNavLink("#contact")} className="text-gray-300 hover:text-white transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>Contact</a>
              <a href="tel:8067293701" className="flex items-center gap-2 text-signal-red font-semibold mt-4">
                <Phone className="w-4 h-4" />
                (806) 729-3701
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
